import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Material components
import { Grid } from '@material-ui/core';

const useStyles = makeStyles({
    alignCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
});

export function CustomBody(props) {

    const classes = useStyles();

    return (
        <Grid container spacing={3} >
            <Grid item xs={false} md={1} lg={2} className={classes.alignCenter} >
            </Grid>

            <Grid item xs={12} md={10} lg={8} className={classes.alignCenter}>
                {props.children}
            </Grid>

            <Grid item xs={false} md={1} lg={2} className={classes.alignCenter} >
            </Grid>
        </Grid>
    );
}